import { makeStyles } from '@material-ui/core';
import { FunctionField } from 'ra-ui-materialui';
import { FC } from 'react';
import AppEditButton from '../../Components/ui/button/AppEditButton';
import AppShowButton from '../../Components/ui/button/AppShowButton';
import AppDatagrid from '../../Components/ui/datagrid/AppDatagrid';
import { AppDateField, AppLinkToEntityField, AppTextField } from '../../Components/ui/field';
import { REVIEW_COLORS, REVIEW_RATING_CHOICES } from './constants';

const useStyles = makeStyles(
  () => ({
    rating: { whiteSpace: 'nowrap' },
    content: { whiteSpace: 'nowrap' },
  }),
  { name: 'ReviewDatagrid' },
);

const ReviewDatagrid: FC<any> = (props) => {
  const { rowClick, ...rest } = props;
  const classes = useStyles();

  return (
    <AppDatagrid {...rest} rowClick={rowClick}>
      <AppTextField source="id" label="ID" />
      <AppDateField source="createdAt" label="Data creazione" showTime />
      <AppTextField source="content" label="Contenuto" headerClassName={classes.content} />
      <FunctionField
        label="Valutazione"
        source="rating"
        render={(record) => (
          <AppTextField
            source="rating"
            customText={
              record
                ? REVIEW_RATING_CHOICES.find((rating) => rating.id === record.rating)?.name
                : '-'
            }
            style={{
              color: REVIEW_COLORS[record?.rating || 'null'],
            }}
          />
        )}
        headerClassName={classes.rating}
      />
      <AppLinkToEntityField
        label="Autore"
        truncate
        targetResource="participants"
        targetResourceId={(r) => r.item?.saleExperiments?.[0]?.participations?.[0]?.fkPresenter}
        originName="admin-review"
        value={(r) => r.author.seller.description}
      />
      <AppLinkToEntityField
        label="Destinatario"
        truncate
        targetResource="people"
        targetResourceId={(r) => r.recipientId}
        originName="admin-review"
        value={(r) =>
          r.recipient.type === 'company'
            ? r.recipient.businessName
            : `${r.recipient.firstName} ${r.recipient.lastName}`
        }
      />
      <AppLinkToEntityField
        label="Lotto"
        source="itemId"
        truncate
        targetResource="items"
        targetResourceId={(r) => r.itemId}
        originName="admin-review"
        value={(r) => r.item.title}
      />
      <AppShowButton variant="contained" color="default" />
      <AppEditButton variant="contained" color="default" />
    </AppDatagrid>
  );
};

export default ReviewDatagrid;
